import { render } from "./PatientAppointments.vue?vue&type=template&id=1808e36f&ts=true"
import script from "./PatientAppointments.vue?vue&type=script&lang=ts"
export * from "./PatientAppointments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__